import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { HashRouter, Route } from 'react-router-dom';
import LayoutContext from 'dashboard/LayoutContext';
import FwPlugins from 'framework-plugins';
import { inizializza as inizializzaPotenzialiIsee } from 'potenziali-pratiche';
import { ViewportProvider } from 'framework-ui-components/Components/V2';
import { getValue as getPreferenza, setValue as setPreferenza } from './utils/salvataggioPreferenze';
import configureStore from './store/configureStore';
import { cambiaUfficio } from './actions/utenteActions';
import { setAnniRegistrati, setAnnoSelezionato } from './actions/dichiarativiActions';

if (window.datiUtente.CodiceUfficioSelezionato != null && window.datiUtente.Uffici.filter((x) => x.CodiceUfficio === window.datiUtente.CodiceUfficioSelezionato).length > 0) {
  window.ufficioSelezionato = window.datiUtente.Uffici.filter((x) => x.CodiceUfficio == window.datiUtente.CodiceUfficioSelezionato)[0];
}

if (window.ufficioSelezionato == null) {
  if (getPreferenza('CodiceUfficio')) {
    const ufficio = getPreferenza('CodiceUfficio');
    if (ufficio && window.datiUtente.Uffici.filter((x) => x.CodiceUfficio === ufficio).length > 0) {
      window.ufficioSelezionato = window.datiUtente.Uffici.filter((x) => x.CodiceUfficio == ufficio)[0];
    } else {
      window.ufficioSelezionato = window.datiUtente.Uffici[0];
    }
  } else {
    window.ufficioSelezionato = window.datiUtente.Uffici[0];
  }
}

if (window.datiUtente.ServizioSelezionato) {
  switch (window.datiUtente.ServizioSelezionato) {
    case '7OL':
      window.location.href = '#/SetteTrenta';
      break;
    case '7NW':
      window.location.href = '#/NewSetteTrenta';
      break;
    case '7OLRIC':
      window.location.href = '#/SetteTrenta/RichiesteEnti';
      break;
    case 'SUC':
      window.location.href = '#/successioni';
      break;
    case 'RIC':
      window.location.href = '#/richiesteenti';
      break;
    case 'IMU':
      window.location.href = '#/imu';
      break;
    case 'ISEE':
      window.location.href = '#/isee';
      break;
    case 'SCI':
      window.location.href = '#/ServiziCittadino';
      break;
    case 'ANF':
      window.location.href = '#/ANF';
      break;
    case 'AUU':
      window.location.href = '#/AssegnoUnicoUniversaleMonoanno';
      break;
    case 'FEA':
      window.location.href = '#/firme';
      break;
    case 'VIP':
      window.location.href = '#/visureipocatastali';
      break;
    case 'PRE':
      window.location.href = '#/prestazioniagevolate';
      break;
    case 'DIS':
      window.location.href = '#/disoccupazioni';
      break;
    default:
      break;
  }
}

FwPlugins.init('dashboard');

const store = configureStore();
setPreferenza('CodiceUfficio', window.ufficioSelezionato.CodiceUfficio);
store.dispatch(cambiaUfficio(window.ufficioSelezionato));
store.dispatch(setAnniRegistrati(window.datiUtente.Anni));

const annoSelezionato = new URLSearchParams(window.location.search).get('annoSelezionato')
  || new URLSearchParams(window.location.hash.split('?')[1]).get('annoSelezionato')
  || getPreferenza('AnnoSelezionato');

if (window.datiUtente.AnnoSelezionato != null) {
  store.dispatch(setAnnoSelezionato(window.datiUtente.AnnoSelezionato));
} else if (annoSelezionato && window.datiUtente.Anni.filter((x) => x.Anno == annoSelezionato).length > 0) {
  store.dispatch(setAnnoSelezionato(annoSelezionato));
}

inizializzaPotenzialiIsee({
  url: window.config.urlPotenzialiPratiche,
  idUtente: window.datiUtente.IdentificativoUtente,
});

render(
  (
    <ViewportProvider>
      <Provider store={store}>
        <HashRouter>
          {/* Routing */}
          <Route path="/" component={LayoutContext} />
        </HashRouter>
      </Provider>
    </ViewportProvider>),
  document.getElementById('appContainer'),
);
